export type PublicStatusTheme = 'light' | 'dark';
export type ConfiguredPublicStatusTheme = PublicStatusTheme | 'auto';

export function parsePublicStatusTheme(value: string | null): PublicStatusTheme | null {
  return value === 'light' || value === 'dark' ? value : null;
}

export function publicStatusThemeStorageKey(slug: string): string {
  return `perspectify:status-theme:${slug}`;
}

export function resolvePublicStatusTheme({
  visitorTheme,
  configuredTheme,
  prefersDark,
}: {
  visitorTheme: PublicStatusTheme | null;
  configuredTheme: ConfiguredPublicStatusTheme;
  prefersDark: boolean;
}): PublicStatusTheme {
  if (visitorTheme) {
    return visitorTheme;
  }

  if (configuredTheme === 'auto') {
    return prefersDark ? 'dark' : 'light';
  }

  return configuredTheme;
}

export function togglePublicStatusTheme(theme: PublicStatusTheme): PublicStatusTheme {
  return theme === 'dark' ? 'light' : 'dark';
}
